module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2816"
    }
  }, [_c('b', [_vm._v("PART I "), _c('br'), _c('i', [_c('big', [_vm._v("Words You Absolutely "), _c('br'), _vm._v("Should Know ")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2926"
    }
  }, [_vm._v("If you pride yourself as a good communicator, you absolutely must know the words in this section. If items on this list are unfamiliar to you, learn them immediately or risk being at an embarrassing loss for words!")]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e24816"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "1",
      "src": "images/1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "2",
      "src": "images/2.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e5994a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Haye_ISBN9781605501390_epub_c4_r1.vue
// module id = 69
// module chunks = 0